import { TAgentIconType } from '../../types/offer-card';
import { TComputedPropMapper } from '../../types/computed-props-mapper';
import { isDealRentCianAgency } from './isDealRentCianAgency';

export const agentIcon: TComputedPropMapper<TAgentIconType> = (props, ctx) => {
  const {
    offer: { newbuilding, isByHomeowner },
  } = props;

  if (isDealRentCianAgency(props, ctx) || (newbuilding && newbuilding.isFromLeadFactory)) {
    return 'cian';
  }

  if (isByHomeowner) {
    return 'person';
  }

  if (newbuilding && newbuilding.isFromBuilder) {
    return 'builder';
  }

  return 'company';
};
